import React, { Suspense } from 'react';
import styles from './Home.module.css';
import HelpBanner from '../../components/HelpBanner/HelpBanner';
import HelpCards from '../../components/HelpCards/HelpCards';

// Lazy load components for better performance
const LazyHelpBanner = React.lazy(() => import('../../components/HelpBanner/HelpBanner'));
const LazyHelpCards = React.lazy(() => import('../../components/HelpCards/HelpCards'));

const HomePage = React.memo(() => {
  return (
    <div className={styles.home_wrap}>
      <Suspense fallback={<div>Loading...</div>}>
        <LazyHelpBanner />
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        <LazyHelpCards />
      </Suspense>
      {/* <div>HomePage</div> */}
    </div>
  );
});

HomePage.displayName = 'HomePage';

export default HomePage;
